import React, { useEffect, useState, useContext } from "react";
import Chrome from 'react-color';
import MyContext from '../../context/MyContext'
import Fonts from './Fonts'

export const OptionPopUp = (props) => {

    var GoogleFonts = require('../../assets/GoogleFonts.json');

    const { setLayersData, LayersData, clone, setRedoLayer, UndoLayer, setUndoLayer, ChangeCount, setChangeCount } = useContext(MyContext)
 
    const StackStore = () => {

        return new Promise((resolve) => {
            let stack = [...UndoLayer];
            let PrevArray = clone(LayersData);
            if (stack.length < 10) {

                stack.push(PrevArray);
                setUndoLayer(stack);
                setRedoLayer([]);

            } else {
                stack.shift();
                stack.push(PrevArray);
                setUndoLayer(stack);
                setRedoLayer([]);

            }
            resolve();
        })

    }

    const [Textcolor, setTextcolor] = useState(props.values.textColor);

    const [Strokecolor, setStrokecolor] = useState(props.values.strokeColor == null ? '#fff' : props.values.strokeColor);

    var ClrChangeStart = false;

    const colorChange = (e) => {

        if (ClrChangeStart === false) {
            ClrChangeStart = true;
            props.setoverlayHide(true)
        }
        setTextcolor(e.rgb);
    }

    const StrokecolorChange = (e) => {

        if (ClrChangeStart === false) {
            ClrChangeStart = true;
            props.setoverlayHide(true)
        }
        setStrokecolor(e.rgb);
    }

    const colorChangeComplete = async (e) => {

        // debugger
        await StackStore();

        const array = Array.from(LayersData);
        for (let i = 0; i < array.length; i++) {
            if (array[i].key === props.values.key) {
                array[i].textColor = e.hex;
                break
            }
        }
        setLayersData(array);
        setChangeCount(ChangeCount + 1)
        ClrChangeStart = false
        setTimeout(function () { props.setoverlayHide(false) }, 200);
 
        //console.log('CompleteCall');

    }

    const StrokecolorChangeComplete = async (e) => {

        await StackStore();
        const array = Array.from(LayersData);
        for (let i = 0; i < array.length; i++) {
            if (array[i].key === props.values.key) {
                array[i].strokeColor = e.hex;
                break
            }
        }
        setLayersData(array);
        setChangeCount(ChangeCount + 1)
        ClrChangeStart = false
        setTimeout(function () { props.setoverlayHide(false) }, 200);
    }

    const close = (e) => {

        props.setcolorShow(false);
        props.setSliderShow(false);
        props.setoverlayHide(false);
        props.setoverlaydiv(false)
    }

    const close2 = (e) => {
        props.setSliderShow(false);
        props.setoverlayHide(false);
        props.setoverlaydiv(false)
    }

    const close3 = (e) => {
        props.setStrokeShow(false);
        props.setoverlayHide(false);
        props.setoverlaydiv(false);
        
    }

    const close4 = (e) => {
// debugger
        props.setFontShow(false);
        props.setoverlayHide(false);
        props.setoverlaydiv(false)
        props.values.optionPopUp = true;
    }

    const upcheck = (e) => {
        setTimeout(function () {
            props.setoverlayHide(false)
        }, 200);
    }

    const [sliderval, setsliderval] = useState(0);
    const [sliderval2, setsliderval2] = useState(0);

    const changed = (e) => {
        //await StackStore();
        if (ClrChangeStart === false) {
            ClrChangeStart = true;
            props.setoverlayHide(true)
        }

        setsliderval(e.target.value);

        const array = Array.from(LayersData);

        for (let i = 0; i < array.length; i++) {
            if (array[i].key === props.values.key) {
                array[i].opacity = e.target.value / 100;
                array[i].originalOpacity = e.target.value / 100;
                break
            }
        }
        setLayersData(array);
    }

    const StrokeChanged = (e) => {

        setsliderval2(e.target.value);

        const array = Array.from(LayersData);

        for (let i = 0; i < array.length; i++) {
            if (array[i].key === props.values.key) {
                array[i].stroke = e.target.value;
                break
            }
        }
        setLayersData(array);
    }

    useEffect(() => {
        // debugger
        setsliderval(props.NowOpacity);
        setsliderval2(props.stroke);
    }, []);

    const DownCheck = () => {
        StackStore();
    }
    const [ShapeColor, setShapeColor] = useState(null)

    const ShapeColorChange = (e) => {
        setShapeColor(e.rgb)
    }

    const ActiveShapeColor = (color) => {
        props.setAciveShapeColor(color)
        setShapeColor(color)
    }


    return (<>

        {props.PopType === "Stroke" && (
            <div key={props.values.key} className="OptPopContainer" tabIndex="0" style={{ top: "150px" }}>
                <div className="OptInner" tabIndex="0" >
                    <div className="boxUpper" tabIndex="0">
                        <div className="popTitle" tabIndex="0">Stroke</div>
                        <span className="material-icons" tabIndex="0" style={{ fontSize: "20px", cursor: "pointer" }} onClick={close3}>close</span>
                    </div>
                    <div className="boxBottom" tabIndex="0" >
                        <div className="slider" tabIndex="0">

                            <input type="range" min="0" max="10"
                                onMouseDown={DownCheck}
                                onChange={StrokeChanged} value={sliderval2} className="sliderInput" tabIndex="0" />

                            <div className="SliderPercentage" tabIndex="0" >
                                <input type="text" readOnly value={sliderval2} required className="popPercntInput" tabIndex="0" />
                                <span tabIndex="0" style={{ fontWeight: "bold" }}>%</span>
                            </div>
                        </div>

                    </div>
                    <div className="boxBottom" tabIndex="0" >

                        <Chrome color={Strokecolor}
                            onChange={StrokecolorChange}
                            disableAlpha={true}
                            onChangeComplete={StrokecolorChangeComplete}
                        />

                    </div>
                </div>
            </div>
        )}

        {props.PopType === "opacity" && (
            <div key={props.values.key} className="OptPopContainer" tabIndex="0" style={{ top: "150px" }}>
                <div className="OptInner" tabIndex="0" >
                    <div className="boxUpper" tabIndex="0">
                        <div className="popTitle" tabIndex="0">Opacity</div>
                        <span className="material-icons" tabIndex="0" style={{ fontSize: "20px", cursor: "pointer" }} onClick={close2}>close</span>
                    </div>
                    <div className="boxBottom" tabIndex="0" >
                        <div className="slider" tabIndex="0">

                            <input type="range" min="0" max="100" onMouseDown={DownCheck} onChange={changed} onMouseUp={upcheck} value={sliderval} className="sliderInput" tabIndex="0" />

                            <div className="SliderPercentage" tabIndex="0" >
                                <input type="text" readOnly value={sliderval} required className="popPercntInput" tabIndex="0" />
                                <span tabIndex="0" style={{ fontWeight: "bold" }}>%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {props.PopType === "ColorPicker" && (<>

            {props.values.type == 'basicShape' && (
                <div className="OptPopContainer" tabIndex="0" style={{ top: "50px" }}>

                    <div className="OptInner" tabIndex="0" >
                        <div className="boxUpper" tabIndex="0">
                            <div className="popTitle" tabIndex="0">Color Picker</div>
                            <span className="material-icons" tabIndex="0" style={{ fontSize: "20px", cursor: "pointer" }} onClick={close}>close</span>
                        </div>
                        {props.values.type == 'basicShape' && (<>

                             {props.values.ColorsFound.length == 0 && (
                                <div className="charClrBox" style={{padding : '5px'}}>
                                    <div className="charClrBoxInner" style={{ background: '#fff' }}>
                                        
                                    </div>
                                </div>
                            )}
                            {props.values.ColorsFound.length != 0 && (
                                props.values.ColorsFound.map((val, index) => {
                                    return (<div onClick={() => ActiveShapeColor(val)} className="charClrBox" style={{ padding: '5px' }}>
                                        <div className="charClrBoxInner" style={{ background: val }}>
                                        </div>
                                    </div>)
                                })
                            )}
                        </>)}

                        <div className="boxBottom" tabIndex="0" >
                            {ShapeColor != null && (
                                <Chrome color={ShapeColor}
                                    onChange={ShapeColorChange}
                                    disableAlpha={true}
                                    onChangeComplete={colorChangeComplete}
                                    className="PickerSize"
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
            {props.values.type != 'basicShape' && (
                <div className="OptPopContainer" tabIndex="0" style={{ top: "50px" }}>

                    <div className="OptInner" tabIndex="0" >
                        <div className="boxUpper" tabIndex="0">
                            <div className="popTitle" tabIndex="0">Color Picker</div>
                            <span className="material-icons" tabIndex="0" style={{ fontSize: "20px", cursor: "pointer" }} onClick={close}>close</span>
                        </div>
                        <div className="boxBottom" tabIndex="0" >

                            <Chrome color={Textcolor}
                                onChange={colorChange}
                                disableAlpha={true}
                                onChangeComplete={colorChangeComplete}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>)}

        {props.PopType === "fontsDropDown" && (
            <div key={props.values.key} className="OptPopContainer" tabIndex="0" style={{ top: "50px", width: '100%' }}>
                <div className="OptInner" tabIndex="0" >
                    <div className="boxUpper" tabIndex="0">
                        <div className="popTitle" tabIndex="0">Fonts</div>
                        <span className="material-icons" tabIndex="0" style={{ fontSize: "20px", cursor: "pointer" }} onClick={close4}>close</span>
                    </div>
                    <div className="boxBottom font-setter" tabIndex="0" style={{ maxHeight: '200px', overflowY: 'scroll' }}>

                        {
                            GoogleFonts.map((value, index) => (
                                <Fonts close={close4} fontName={value.fontName} fontFamily={value.fontFamily} googleFontUrl={value.googleFontUrl} layervalue={props.values}></Fonts>
                            ))
                        }

                    </div>
                </div>
            </div>
        )}
    </>)
}
export default OptionPopUp;